// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MoveProjectModal-module__fieldContainer--PWJbc{display:flex;flex-direction:column;align-self:flex-start;width:100%}.MoveProjectModal-module__fieldLabel--qOxTr{font-size:14px;font-weight:500;color:#707070}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldContainer": `MoveProjectModal-module__fieldContainer--PWJbc`,
	"fieldLabel": `MoveProjectModal-module__fieldLabel--qOxTr`
};
module.exports = ___CSS_LOADER_EXPORT___;
